import { Box, BoxProps, styled, Typography } from '@mui/material'
import React from 'react'

import GreatValueIcon from '../../../components/project/icons/GreatValueIcon'
import PopularIcon from '../../../components/project/icons/PopularIcon'
import RecommendIcon from '../../../components/project/icons/RecommendIcon'
import { COLORS } from '../../../constants/colors'
import { BannerRadioButtonStyle } from './BannerRadioButton'

export enum BannerType {
  Recommend = 'recommend',
  GreatValue = 'greatValue',
  Hot = 'hot',
  None = ''
}
interface BannerLabelProps {
  bannerType: BannerType
  style?: BannerRadioButtonStyle
}

interface StyledBannerLabelProps extends BoxProps {
  bannerType: BannerType
}

const BannerLabel = ({ bannerType, style = BannerRadioButtonStyle.Primary }: BannerLabelProps) => {
  const isPrimaryStyle = style === BannerRadioButtonStyle.Primary
  const StyledBannerLabel = isPrimaryStyle ? PrimaryStyledBannerLabel : SecondaryStyledBannerLabel

  const getBannerLabelText = () => {
    if (bannerType === BannerType.Recommend) return 'แนะนำ'
    if (bannerType === BannerType.Hot) return 'HOT!'
    if (bannerType === BannerType.GreatValue) return 'สุดคุ้ม'
    return ''
  }

  const getBannerIcon = () => {
    if (bannerType === BannerType.Recommend) return <RecommendIcon />
    if (bannerType === BannerType.Hot) return <PopularIcon />
    if (bannerType === BannerType.GreatValue) return <GreatValueIcon />
    return ''
  }
  return (
    <StyledBannerLabel bannerType={bannerType}>
      {isPrimaryStyle ? (
        <Typography color={COLORS.white} variant='body1' fontWeight={500}>
          {getBannerLabelText()}
        </Typography>
      ) : (
        <>
          {getBannerIcon()}
          <Typography variant='body2' fontWeight={500} marginLeft={1}>
            {getBannerLabelText()}
          </Typography>
        </>
      )}
    </StyledBannerLabel>
  )
}

const PrimaryStyledBannerLabel = styled(Box, {
  shouldForwardProp: (props) => !['bannerType'].includes(props as string)
})<StyledBannerLabelProps>(({ theme, bannerType }) => ({
  backgroundColor:
    bannerType === BannerType.Hot
      ? COLORS.pink400
      : bannerType === BannerType.GreatValue
      ? COLORS.purple500
      : theme.palette.success.main,
  textAlign: 'center',
  padding: theme.spacing(0.5, 0),
  transform: 'rotate(45deg)',
  transformOrigin: '',
  position: 'absolute',
  right: -27.5,
  top: 10,
  width: '100px'
}))

const SecondaryStyledBannerLabel = styled(Box, {
  shouldForwardProp: (props) => !['bannerType'].includes(props as string)
})<StyledBannerLabelProps>(({ theme, bannerType }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(2),
  backgroundColor:
    bannerType === BannerType.Hot
      ? COLORS.red200
      : bannerType === BannerType.GreatValue
      ? COLORS.purple200
      : COLORS.green100
}))

export default BannerLabel
